import Backbone from 'backbone'
import _ from 'underscore'
import TestResultViewTemplate from '../templates/test-results.tpl'
import TestResultEmailTemplate from '../templates/test-results-email.tpl'
import ContentHeaderView from './content-header'
import titles from '../titles'
import user from '../user'
import Alert from '../helpers/alert'
import config from '../config'

const TestResultView = Backbone.View.extend({
    el: '#current-view',
    events: {
        'click .email-btn': 'sendEmail'
    },
    initialize(options) {
        this.template = _.template(TestResultViewTemplate)
        this.emailTemplate = _.template(TestResultEmailTemplate)

        this.model = titles.findWhere({ image_prefix: options.image_prefix })

        this.model.set('mode', 'result')

        // perform a results sync to send last result to server
        user.get('results').sync()
            .catch(Alert)
    },
    render() {
        this.$el.html(this.template({
            color: this.model.get('color'),
            mode: 'result',
            star: this.model.get('test').get('star'),
            score: this.model.get('test').get('score'),
            count: this.model.get('test').get('count'),
            accuracy: this.model.get('test').get('accuracy'),
            start_timestamp: this.model.get('test').get('start_timestamp'),
            end_timestamp: this.model.get('test').get('end_timestamp'),
        }))

        const headerView = new ContentHeaderView({model: this.model})
        this.$('#header').append(headerView.render().el)

        return this
    },
    sendEmail() {
        const to = this.$el.find('#email').val()
        const subject = user.get('username') + ': ' + this.model.get('name')
        const html = this.emailTemplate({
            app: config.get('name'),
            username: user.get('username'),
            score: this.model.get('test').get('score'),
            count: this.model.get('test').get('count'),
            accuracy: this.model.get('test').get('accuracy'),
            start_timestamp: this.model.get('test').get('start_timestamp'),
            end_timestamp: this.model.get('test').get('end_timestamp'),
        })

        this.model.get('test').sendEmail(to, subject, html)
            .then((response) => Alert(response.message))
            .catch(Alert)

        return this
    }
})

export default TestResultView
